import React, { Component } from 'react'
import { connect } from 'react-redux'
import { confirmationPop, setSuccessFailPop } from '../../action/viewBillAction2'
import { checkOut, guestBillDetails, guestHistroy } from '../../../action/viewBillAction'
import {setLoader} from '../../action/homeAction'
import {withTranslation} from "react-i18next";
import {DEMO, ENABLE_NEW_CHECKOUT_FLOW} from '../../../config/constant';
import smooch from 'smooch'

class confirmationPopUp extends Component {

    constructor(props){
        super(props)
        this.interval = null
        this.timeout = null
        this.state = {
            roomNumber : localStorage.getItem("room"),
            timeDelay: null,
            timerTimeout: null,
            checkOutButtonClicked:false
        }
    }

    callbackBillDetails = (xcValue, status, msg) => {
        if(status){
            console.log('xcValue', xcValue)
            if(xcValue=='SUCCESS'){
                console.log('checkout success');
                localStorage.removeItem("GuestJourneySessionToken");
                localStorage.removeItem("room");
                localStorage.removeItem('VerifiedUser')
                clearInterval(this.interval);
                clearTimeout(this.timeout);
                this.props.setLoader(false, '');
                this.props.checkoutSuccess(true);
                this.props.setSuccessFailPop(true, true);
            } else if(xcValue=='FAILED'){
                console.log('checkout failed status:', status)
                clearTimeout(this.timeout);
                this.billDetailsFailure(msg);
            }
        }  else {
            console.log('checkout failed status:', status)
            clearTimeout(this.timeout);
            this.billDetailsFailure(msg);
        }
    }

    billDetailsFailure = (errorMsg) => {
        clearInterval(this.interval);
        if (this.props.selectedGuest) {
            this.props.guestHistroy(this.props.selectedGuest, (status) => {
            console.log("guestHistory refreshed after checkout failure:", status);
        })
        }
        this.props.setLoader(false, '');
        this.props.setSuccessFailPop(true, false, errorMsg);
    }

    cancelCheckOut = () => {
        this.props.confirmationPop(false);
    }

    onContinue = () => {
        this.setState({checkOutButtonClicked: true});
        this.props.confirmationPop(false);
        this.props.setLoader(true, 'Please wait checkout is in process');
        this.props.checkOut(this.props.selectedGuest, this.props.billTotal, this.onSuccess, this.onFailure);
    }

    onSuccess = (msg) => {
        console.log("onSuccess");
        if(DEMO || !ENABLE_NEW_CHECKOUT_FLOW){
            this.props.setLoader(false, '');
            this.props.checkoutSuccess(true);
            this.props.setSuccessFailPop(true, true);
            return;
        }
        this.interval = window.setInterval(
            () => {
                console.log('Calling bill details api')
                this.props.guestBillDetails(this.props.selectedGuest, this.callbackBillDetails);
            }, this.state.timeDelay
            
        )
        this.timeout = window.setTimeout(
            () => {
                console.log('Checkout failed did not find the xc value', this.state.timerTimeout, this.state.interval)
                this.billDetailsFailure()
            }, this.state.timerTimeout
        )
    }

    onFailure = (msg) => {
        console.log("onFailure");
        this.props.setLoader(false, '');
        this.props.setSuccessFailPop(true, false, msg);
        if (this.props.selectedGuest) {
            this.props.guestHistroy(this.props.selectedGuest, (status) => {
            console.log("guestHistory refreshed after checkout failure:", status);
        });
    }
    }

    componentDidMount() {
        if(this.props.timeIntervalsBillDetail){
            console.log('this.props.timeIntervalsBillDetail',this.props.timeIntervalsBillDetail)
            let timeDelay= this.props.timeIntervalsBillDetail.split(',')[0] * 1000
            let timerTimeout= this.props.timeIntervalsBillDetail.split(',')[1] * 1000
            this.setState({timeDelay:timeDelay, timerTimeout:timerTimeout})
            console.log('timeDelay', timeDelay, timerTimeout)
        }
    }

    render() {
        const { t } = this.props
        return (
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content">
                            <div class="header icon-header">
                                <div class="header-text">
                                    <h3>{t('view_bill.popup_heading')}</h3>
                                    <p>{t('view_bill.total')} {this.props.currencyCode} {this.props.billTotal ? this.props.billTotal : 0.00}</p>
                                    <p>{t('view_bill.room_no')} {this.state.roomNumber}</p>
                                </div>
                                <div class="header-icon">
                                    <i class="fas fa-suitcase"></i>
                                </div>
                            </div>
                            {t('view_bill.checkout_confirm_txt')}
					</div>
                        <div class="overlay-controls">
                            <button onClick={this.cancelCheckOut} class="button secondary">{t('view_bill.cancel')}</button>
                            <button onClick={this.onContinue} class={`button ${this.state.checkOutButtonClicked ? "checkoutButtonClicked":""}`} style = {{backgroundColor:this.props.menuColor.assetBackgroundSelectorColor, color : this.props.menuColor.assetFontSelectorColor}}>{t('view_bill.continue')}</button>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        billTotal: state.store.viewBill.billTotal,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        selectedGuest: state.store2.viewBill.selectedGuest,
        timeIntervalsBillDetail: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.EXPRESS_CHECKOUT_TIME_INTERVALS : "",
    }
}

export default connect(
    mapStateToProps,
    {
        confirmationPop,
        checkOut,
        setSuccessFailPop,
        guestBillDetails,
        setLoader,
        guestHistroy
    }
)(withTranslation('translations')(confirmationPopUp));